import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

/** Protege la Agenda de pagos: acceso por permiso explícito desde Administración. */
const RequirePayments = ({ children }: { children: React.ReactNode }) => {
  const { loading, canAccessPayments } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-muted-foreground">Cargando…</p>
      </div>
    );
  }
  if (!canAccessPayments) return <Navigate to="/hub" replace />;
  return <>{children}</>;
};

export default RequirePayments;
